const $stepper = document.querySelector('.stepper');
const $steppers = document.querySelectorAll('.stepper');
if($stepper) {
    $steppers.forEach(el => {
        const $stepperInput = el.querySelector('.stepper__input');
        const $stepperMinus = el.querySelector('.stepper__btn--minus')     
        const $stepperPlus = el.querySelector('.stepper__btn--plus') 
        let maxValue = 5;
    
        $stepperInput.addEventListener('change', (e) => {
            let valueInput = e.currentTarget.value;
            console.log(valueInput);
            if( valueInput == "" || valueInput < 1 || valueInput == NaN || isNaN(valueInput)){
                e.currentTarget.blur();
                e.currentTarget.value = 1;
                $stepperMinus.classList.add('stepper__btn--disabled')
                $stepperPlus.classList.remove('stepper__btn--disabled')
            }
            if(valueInput > maxValue ) {
                e.currentTarget.blur();
                e.currentTarget.value = maxValue;
                $stepperPlus.classList.add('stepper__btn--disabled')
                $stepperMinus.classList.remove('stepper__btn--disabled')
            }
        })
    
        $stepperInput.addEventListener('keydown', (e) => {
            if(e.currentTarget.value <= 1){
                // e.currentTarget.value = 1;
                $stepperMinus.classList.add('stepper__btn--disabled')
            } else {
                $stepperMinus.classList.remove('stepper__btn--disabled')
            }
    
    
            if(e.currentTarget.value > maxValue){
                e.currentTarget.blur();
                e.currentTarget.value = maxValue;
                $stepperPlus.classList.add('stepper__btn--disabled')
    
            } else {
                $stepperPlus.classList.remove('stepper__btn--disabled')
            }
        })
    
        $stepperPlus.addEventListener('click', ()=> {
            let currentValue = parseInt($stepperInput.value);
            currentValue++;
            $stepperInput.value = currentValue;
            $stepperMinus.classList.remove('stepper__btn--disabled')
    
    
    
            if($stepperInput.value >= maxValue){
                $stepperInput.value = maxValue;
                $stepperPlus.classList.add('stepper__btn--disabled')
                $stepperMinus.classList.remove('stepper__btn--disabled')
            } else {
                $stepperPlus.classList.remove('stepper__btn--disabled')
            }
        })
    
        $stepperMinus.addEventListener('click', ()=> {
            let currentValue = parseInt($stepperInput.value);
            currentValue--;
            $stepperInput.value = currentValue;
            $stepperPlus.classList.remove('stepper__btn--disabled')
    
    
    
            if($stepperInput.value <= 1){
                // $stepperInput.value = 1;
                $stepperMinus.classList.add('stepper__btn--disabled')
            
            } else {
                $stepperMinus.classList.remove('stepper__btn--disabled')
            }
    
        })
    
    
    })
    
    
    
}

